var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.359,
    height: 11.467,
    viewBox: "0 0 14.359 11.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44309",
    "data-name": "Group 44309",
    transform: "translate(-9.438 -1.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21936",
    "data-name": "Path 21936",
    d: "M0,0H6.608V6.609",
    transform: "translate(18.063 2.317) rotate(45)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21937",
    "data-name": "Path 21937",
    d: "M512.631-1535H501",
    transform: "translate(-490.812 1541.99)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow-1.21f18c866b08cbe56300f85253399e91.svg";
export { ForwardRef as ReactComponent };